import moment from 'moment'

type HeaderProfitNLossProps = {
  label: string
  startDate: string
  endDate?: string
  singleDate?: boolean
}

export const HeaderProfitNLoss = ({ label, startDate, endDate, singleDate }: HeaderProfitNLossProps) => (
  <div className="ml-[20px] mt-3 font-bold uppercase text-[12px]">
    <span>PT HAWK</span>
    <span className='mx-2'>|</span>
    {/* <span>{label}</span> */}
    <span className="capitalize">
      {singleDate && moment(startDate).format("DD MMMM YYYY")}
      {!singleDate && `${moment(startDate).format("DD MMMM YYYY")} - ${moment(endDate).format("DD MMMM YYYY")}`}
    </span>
  </div>
)